enum RegressionModel {
  Linear = "linear",
  Poly3 = "poly_3",
  Poly4 = "poly_4",
  Loess = "loess",
  MovingAverage = "moving_average",
  ScottMovingAverage = "scott_moving_average",
  Arima = "arima",
}

export default RegressionModel;
